import React, { useState } from "react";
import { Container, Row, Card, Col, Form as BSForm } from "react-bootstrap";
import Loader from "react-spinner-loader";
import SigniteButton from "../../../ui-elements/signite-button/signiteButton";
import { CandidatesTable } from "../candidate-listing-table/candidatesTables";
import ClientCandidateService from "../../../../services/client-services/clientCandidateService";

const SelfRegisteredCandidates = () => {
    const [loader, setLoader] = useState(true);
    const [candidatesLoading, setCandidatesLoading] = useState(true);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [updatedFirstName, setUpdatedFirstName] = useState("");
    const [updatedLastName, setUpdatedLastName] = useState("");

    const [candidateTableData, setCandidateTableData] = useState({
        columns: [],
        data: [],
    });

    const fetchData = async ({ pageIndex = 0, pageSize = 10 }) => {

        setCandidatesLoading(true);
        try {
            const body = {
                page: pageIndex,
                size: pageSize,
                selfRegistered: true,
                firstName: updatedFirstName || "",
                lastName: updatedLastName || "",
            };

            const response = await ClientCandidateService.osInternalUserSearch(body);

            const candidates = response?.data?.candidates || [];

            const tableData = {
                columns: [
                    { header: "Candidate ID", accessorKey: "candidateId" },
                    { header: "First Name", accessorKey: "firstName" },
                    { header: "Last Name", accessorKey: "lastName" },
                    { header: "Email", accessorKey: "email" },
                    { header: "Phone Number", accessorKey: "phoneNumber" },
                ],
                data: candidates.map((item) => ({
                    candidateId: item.candidateId,
                    firstName: item.candidate?.personalDetails?.firstName || "-",
                    lastName: item.candidate?.personalDetails?.lastName || "-",
                    email: item.candidate?.personalDetails?.primaryEmailId || "-",
                    phoneNumber: item.candidate?.personalDetails?.primaryPhoneNumber || "-",
                })),
            };

            setCandidateTableData(tableData);
            setCandidatesLoading(false);
            setLoader(false);

            return {
                rows: {
                    data: tableData.data,
                    columns: tableData.columns,
                },
                pageCount: response?.data?.pageCount ?? 1,
            };
        } catch (error) {
            console.error("Error fetching self registered:", error);
            setCandidatesLoading(false);
            setLoader(false);
            return {
                rows: { data: [], columns: [] },
                pageCount: 0,
            };
        }
    };

    const triggerCandidateSearch = (fname, lname) => {
        setLoader(true);
        setUpdatedFirstName(fname);
        setUpdatedLastName(lname);
        fetchData({ pageIndex: 0, pageSize: 10 });
    };

    const setSearchField = (event) => {
        switch (event.target.id) {
            case 'firstName':
                setFirstName(event.target.value);
                if (event.target.value === "" && lastName === "") {
                    triggerCandidateSearch("", "");
                }
                break;
            case 'lastName':
                setLastName(event.target.value);
                if (event.target.value === "" && firstName === "") {
                    triggerCandidateSearch("", "");
                }
                break;
        }
    };

    return (
        <Container fluid>
            <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
            <Row>
                <Card className="p-0">
                    <Card.Header style={{ backgroundColor: "white" }}>
                        <BSForm className="pr w-100 m-0">
                            <Row className="align-items-center">
                                <Col lg={4}></Col>
                                <Col xs="auto">
                                    <BSForm.Control
                                        className="mb-2"
                                        id="firstName"
                                        placeholder="First Name"
                                        value={firstName}
                                        onChange={(e) => setSearchField(e)}
                                        spellCheck='false'
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                triggerCandidateSearch(firstName, lastName);
                                            }
                                        }}
                                    />
                                </Col>

                                <Col xs="auto">
                                    <BSForm.Control
                                        className="mb-2"
                                        id="lastName"
                                        placeholder="Last Name"
                                        value={lastName}
                                        onChange={(e) => setSearchField(e)}
                                        spellCheck='false'
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                triggerCandidateSearch(firstName, lastName);
                                            }
                                        }}
                                    />
                                </Col>

                                <Col xs="auto">
                                    <SigniteButton
                                        variant={'primary'}
                                        className="mb-2 ms-2"
                                        onClick={() => triggerCandidateSearch(firstName, lastName)}
                                    >
                                        Search
                                    </SigniteButton>
                                </Col>
                            </Row>
                        </BSForm>
                    </Card.Header>

                    <Card.Body style={{ backgroundColor: "white" }}>
                        <CandidatesTable
                            columns={candidateTableData.columns}
                            fetchData={fetchData}
                            firstName={updatedFirstName}
                            lastName={updatedLastName}
                        />
                    </Card.Body>
                </Card>
            </Row>
        </Container>
    );
};

export default SelfRegisteredCandidates;